import { styled } from 'parkdepot-shared/theme'
import { BadgeVariant } from './types'
import { colourMapping } from './utils'

export const BadgeContainer = styled<'div', { $variant: BadgeVariant }>('div', ({ $theme, $variant }) => {
    const colours = colourMapping($theme)

    return {
        borderRadius: $theme.sizing.scale300,
        padding: '1px 7px',
        display: 'flex',
        gap: $theme.sizing.scale100,
        alignItems: 'center',
        background: colours[$variant].background,
        width: 'fit-content',
        ...$theme.typography.LabelXSmall,
        lineHeight: $theme.sizing.scale700,
        color: colours[$variant].main
    }
})

export const BadgeRound = styled<'div', { $variant: BadgeVariant }>('div', ({ $theme, $variant }) => {
    const colours = colourMapping($theme)

    return {
        width: '7px',
        height: '7px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colours[$variant].secondary
    }
})

export const BadgeInnerRound = styled<'div', { $variant: BadgeVariant }>('div', ({ $theme, $variant }) => {
    const colours = colourMapping($theme)

    return {
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        backgroundColor: colours[$variant].main
    }
})
